import React from "react"
import types from "prop-types"
import { Button } from "components/shared/buttons"

const OpenConversationButton = ({ onClick }) => (
  <Button
    className="border border-light-300 text-focus"
    onClick={onClick}
    text="+ Open New Conversation"
  />
)

OpenConversationButton.propTypes = {
  onClick: types.func.isRequired,
}

export default OpenConversationButton
